import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHowToPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 17.5002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40973 1.71547 1.71547 1.40973 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H13.4002C13.9602 1 14.2407 1 14.4546 1.10899C14.6427 1.20487 14.7948 1.35774 14.8906 1.5459C14.9996 1.75981 15 2.04005 15 2.6001V14.4001C15 14.9601 14.9996 15.2398 14.8906 15.4537C14.7948 15.6419 14.6429 15.7952 14.4548 15.8911C14.2411 16 13.961 16 13.402 16H3.25C2.00736 16 1 17.0074 1 18.25C1 18.6642 1.33579 19 1.75 19H12.402C12.961 19 13.2411 19 13.4548 18.8911C13.6429 18.7952 13.7948 18.642 13.8906 18.4538C13.9996 18.2399 14 17.9601 14 17.4V16",
		stroke: "#414D73",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHowToPlay;
